"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalHistoryScrollDirection = exports.isTerminalCommand = exports.isFileSystemDirectory = exports.TerminalMessageType = void 0;
const lodash_1 = require("lodash");
var TerminalMessageType;
(function (TerminalMessageType) {
    TerminalMessageType[TerminalMessageType["Message"] = 0] = "Message";
    TerminalMessageType[TerminalMessageType["Error"] = 1] = "Error";
    TerminalMessageType[TerminalMessageType["Echo"] = 2] = "Echo";
})(TerminalMessageType = exports.TerminalMessageType || (exports.TerminalMessageType = {}));
function isFileSystemDirectory(value) {
    return Boolean((0, lodash_1.get)(value, 'items'));
}
exports.isFileSystemDirectory = isFileSystemDirectory;
function isTerminalCommand(value) {
    return Boolean((0, lodash_1.get)(value, 'func'));
}
exports.isTerminalCommand = isTerminalCommand;
var TerminalHistoryScrollDirection;
(function (TerminalHistoryScrollDirection) {
    TerminalHistoryScrollDirection[TerminalHistoryScrollDirection["Up"] = 0] = "Up";
    TerminalHistoryScrollDirection[TerminalHistoryScrollDirection["Down"] = 1] = "Down";
})(TerminalHistoryScrollDirection = exports.TerminalHistoryScrollDirection || (exports.TerminalHistoryScrollDirection = {}));
//# sourceMappingURL=types.js.map